import * as React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import useGlobalStyles from 'styles/globalStyles';
import DailyStats from "./DailyStats";
import NotificationDetails from "./NotificationDetails";

const localStyles = makeStyles(theme => ({
    card: {
        marginBottom: theme.spacing(3),
        '& table.react-table': {
            border: 'none',
            marginBottom: '15px',
            '& th': {
                fontWeight: 'normal',
            },
            '& input': {
                padding: '5px',
                margin: '3px',
            },
            '& input[type=checkbox]': {
                display: 'none',
            },
            '& thead': {
                '& tr:first-of-type': {
                    display: 'none',
                },
            },
            '& th, & td': {
                borderBottomColor: '#ccc',
                borderTopColor: '#ccc',
                borderRightColor: '#ccc',
                borderLeftColor: '#ccc',
            },
        },
    },
    content: {
        width: 'auto',
        overflow: 'scroll',
    },
    root: {
        flexGrow: 1,
        maxWidth: 752,
    },
}));

const NotificationInfo = () => {
    const localClasses = localStyles();
    const globalClasses = useGlobalStyles();
    return (
        <React.Fragment>

            <Grid item lg={8} md={8} style={{marginTop: '20px'}} xs={12}>
                <div>
                    <NotificationDetails localClasses={localClasses} globalClasses={globalClasses}/>
                    <DailyStats localClasses={localClasses} globalClasses={globalClasses}/>
                </div>
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(NotificationInfo);
